import { render, staticRenderFns } from "./InfoRegister.vue?vue&type=template&id=75e4afc0&scoped=true&"
import script from "./InfoRegister.vue?vue&type=script&lang=js&"
export * from "./InfoRegister.vue?vue&type=script&lang=js&"
import style0 from "./InfoRegister.vue?vue&type=style&index=0&id=75e4afc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e4afc0",
  null
  
)

export default component.exports